import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Scroll from 'react-scroll';


export default class SubMenu extends Component {
  constructor(props) {
    super(props);
    const { selected } = this.props;
    this.state = {
      selected,
    };
  }

  handleChange(selected, id) {
    const { handleChange } = this.props;
    this.setState({ selected });
    handleChange(selected);
    if (id) {
      Scroll.scroller.scrollTo(id, {
        delay: 0,
        duration: 500,
        offset: 10,
        smooth: true,
      });
    }
  }

  render() {
    const { items } = this.props;
    const { selected } = this.state;
    const links = [];
    let chars = 0;

    items.forEach((link, i) => {
      if (link.name) {
        chars = link.name ? chars + link.name.length : chars;
        if (link.href === '#weather') return;
        links.push(
          <li
            key={ `landing-page__sub-menu__item-${i}` }
            className={ `landing-page__sub-menu__item ${selected === link.name ? '-is-selected' : ''}` }
            onClick={ this.handleChange.bind(this, link.name, link.href) }
          >
            <p className="landing-page__sub-menu__item__link">
              { link.name }
            </p>
          </li>
        );
      }
    });
    return (
      <ul className="landing-page__sub-menu">
        <div
          className="landing-page__sub-menu__inocuos-container"
          style={ { width: (chars * 9) + (links.length * 20) } }
        >
          { links }
        </div>
      </ul>
    );
  }

}

SubMenu.defaultProps = {
  selected: '',
};

SubMenu.propTypes = {
  handleChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  selected: PropTypes.string,
};
